import React, { useState, useEffect } from "react";
import { Button, Col, Modal, Row, Spin, Typography } from "antd";
import RewardImg from "../../../assets/rewardImg.png";
import { useWindowDimensions } from "../examPortal/testBoard";
import Diamond from "../../../assets/diamond.svg";
import { retriveToken, fetchAuth } from "../../../services/AuthServices";
import { SecureGet, SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import { useDispatch, useSelector } from "react-redux";
// import { login } from "../../../actions/loginAction";
import { login } from "../../../reducers/loggedinuser";
import Alert from "../../common/alert";
import { useNavigate } from "react-router-dom"; // For routing

const CategoreyRewards = ({ categoryId }) => {
  const { height } = useWindowDimensions();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryRewards, setCategoryRewards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rewardObject, setRewardObject] = useState();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleOpen = (item) => {
    setRewardObject(item);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleClaimReward = () => {
    setIsModalOpen(false);
    SecurePost({
      url: `${apis.CLAIM_REWARD}`,
      data: {
        rewardId: rewardObject._id,
        date: new Date(),
      },
    })
      .then((response) => {
        if (response.data.success) {
          const token = retriveToken();
          if (token && token !== "undefined") {
            fetchAuth(token).then((response) => {
              dispatch(login(response.data.user)); // Dispatch login action
            });
          }
          Alert("success", "Success!", response.data.message);
        } else {
          Alert("error", "Error!", response.data.message);
        }
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", message);
      });
  };

  useEffect(() => {
    setIsLoading(false);
    const token = retriveToken();
    if (token && token !== "undefined" && categoryId) {
      SecureGet({
        url: apis.GET_REWARD_CATEGORY + "/" + categoryId,
        params: {
          Token: token,
        },
      }).then((response) => {
        setCategoryRewards(response?.data?.data || []);
        setIsLoading(true);
      });
    }
  }, [categoryId]);

  return (
    <>
      {isLoading ? (
        <Row
          style={{
            display: "flex",
            overflow: "hidden",
            padding: "40px 0px",
            marginBottom: 12,
          }}
          gutter={[24, 24]}
        >
          {categoryRewards?.map((item) => (
            <Col key={item._id} className="gutter-row" span={8}>
              <div className="reward_Card">
                <div className="rewardImgBox">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <img
                      width={"60%"}
                      height={height <= 760 ? "100px" : height * 0.16151515151}
                      src={apis.BASE_LOCAL_URL + "/" + item?.imgUrl}
                      alt={item?.name}
                    />
                  </div>
                  <Typography className="rewardTitle">{item?.name}</Typography>
                  <Typography className="rewardDesc">
                    {(() => {
                      const words = item?.description?.split(/\s+/) || [];
                      return (
                        words.slice(0, 10).join(" ") +
                        (words.length > 10 ? "..." : "")
                      );
                    })()}
                  </Typography>
                </div>
                <div className="rewardPointsBox">
                  <div
                    style={{ display: "flex", gap: 2, alignItems: "center" }}
                  >
                    <img width={"23px"} src={Diamond} alt="diamond" />
                    <Typography className="rewardsPoints">
                      {parseInt(item?.cost || 0)?.toLocaleString()} points
                    </Typography>
                  </div>
                  <Button
                    type="primary"
                    className="reedemButton"
                    onClick={() => handleOpen(item)}
                  >
                    Redeem
                  </Button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <Modal
        open={isModalOpen}
        footer={null}
        closable={false}
        onCancel={handleClose}
        className="rewardMModal"
        width={450}
        style={{
          top: "30%",
          borderRadius: "25px",
          backgroundColor: "#F1F1F1",
        }}
      >
        {auth?.userDetails?.points < rewardObject?.cost ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <Typography className="reviewCost">
                Oops! You don't have enough points to get this reward.
              </Typography>
            </div>
            <div className="redemeActions">
              <Button
                className="reedemButtonCancel"
                type="primary"
                style={{
                  width: "60%",
                }}
                onClick={handleClose}
              >
                Ok
              </Button>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <Typography className="reviewCost">Reward cost:</Typography>
              <div
                style={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <img width={"33px"} src={Diamond} alt="diamond" />
                <Typography className="rewardsPointsPopup">
                  {parseInt(rewardObject?.cost || 0)?.toLocaleString()} points
                </Typography>
              </div>
            </div>
            <div className="redemeActions">
              <Typography>
                Points after purchase: <img src={Diamond} alt="diamond" />{" "}
                {(
                  auth?.userDetails?.points - rewardObject?.cost || 0
                ).toLocaleString()}
              </Typography>
              <Button
                className="reedemButton"
                type="primary"
                style={{
                  width: "60%",
                }}
                onClick={handleClaimReward}
              >
                Confirm
              </Button>
              <Button
                className="reedemButtonCancel"
                type="primary"
                style={{
                  width: "60%",
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default CategoreyRewards;
